import autobind from 'react-autobind'
import React, { Component } from 'react';
import renderHTML from 'react-render-html';

export default class RequestMessage extends Component {

    constructor(props) {
        super(props);
        autobind(this);
    }

    getTimelineContent(position, formatedDate, formatedTime) {
        switch (position) {
            case 'left':
                return <div className="timeline-content timeline-type comment">
                    <div className="timeline-user-details">
                        <img src={this.props.userImagePath} alt="Avatar" className="circle" />
                        <span className="timeline-ar-date">{formatedDate}</span>
                        <span className="timeline-time">{formatedTime}</span>
                    </div>
                    <div className="timeline-summary text-left w-100">
                        {this.props.message ? renderHTML(this.props.message) : ''}
                    </div>
                </div>
            case 'right':
                return <div className="timeline-content timeline-type comment">
                    <div className="timeline-summary text-right w-100">
                        {this.props.message ? renderHTML(this.props.message) : ''}
                    </div>
                    <div className="timeline-user-details pl-4">
                        <img src={this.props.userImagePath} alt="Avatar" className="circle" />
                        <span className="timeline-ar-date">{formatedDate}</span>
                        <span className="timeline-time">{formatedTime}</span>
                    </div>
                </div>
            default:
                return null
        }
    }

    render() {

        const date = new Date(this.props.date);
        const formatedDate = date.toLocaleDateString('en-us', { day: 'numeric', month: 'long', year: 'numeric' });
        const formatedTime = date.toLocaleTimeString('en-us', { hour: 'numeric', minute: 'numeric' });

        return (
            <li className={'timeline-item timeline-item-detailed ' + this.props.position}>
                {this.getTimelineContent(this.props.position, formatedDate, formatedTime)}
            </li>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Request/RequestMessage.js